import {Form, formsStore, Screen} from '../../../stores/Form';
import {RecordEditState, UpdateActions} from '../../../stores/Form/enums';
import {getUpdateActionType} from '../../../stores/Form/utils';
import {showFormClientSideMessage, undoApproveProps} from './messages';
import messagesText from '../../../_shared/Messages/texts';
import {startRecordUndo} from './form';
import {priority} from '@priority-software/priority-proto-api/lib';

export const undoAction = async (withMsg = true) => {
    const screen: Screen = formsStore.currentScreen;
    const form: Form = screen.getActiveForm();
    const currentRecord = form.records[form.currentRow];
    const currentField = form.activeField();
    const updateAction: UpdateActions = getUpdateActionType(form, true, screen.editMode);

    if (updateAction === UpdateActions.save || updateAction === UpdateActions.update_save) {
        if (currentRecord?.isNew && withMsg) {
            showFormClientSideMessage(
                screen.session,
                priority.netitems.shared.Message.Type.Warning,
                {
                    title: messagesText.ctrlZTitle,
                    onConfirm: () => undoAll(screen),
                    ...undoApproveProps()
                }
            );
        } else {
            await undoAll(screen);
        }
    } else {
        if (currentField && currentField.currentValue !== currentField.origValue) {
            undoLastChange(screen);
        }
    }
};

export const undoAll = async (screen: Screen) => {
    if (!screen) {
        return;
    }
    await startRecordUndo(screen.getActiveForm());
    screen.editMode = RecordEditState.default;
};

export const undoLastChange = (screen: Screen) => {
    const activeForm = screen.getActiveForm();
    if (activeForm) {
        const activeField = activeForm.records[activeForm.currentRow].getField(
            activeForm.currentColumnId
        );
        if (activeField) {
            // Reset control state to default
            activeForm.updateRecordValues(activeForm.currentRow, [
                {ColumnID: activeField.columnId, Value: activeField.Value}
            ]);

            if (screen.editMode === RecordEditState.error) {
                screen.editMode = RecordEditState.shouldUpdate;
            }
        }
    }
};
